
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Jai Jai Satchitswaroopa Swami Ganraya" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Aarti "Jai Jai Satchitswaroopa Swami Ganraya" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Jai Jai Satchitswaroopa Swami Ganraya, Gajanan Maharaj Aarti, Gajanan Maharaj, जय सत्चितस्वरूपा स्वामी गणराया, Aarti for gajanan, wami Ganraya Aarti, Jai Jai Satchitswaroopa Aarti lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jai Jai Satchitswaroopa Swami Ganraya, Gajanan Maharaj Aarti, Gajanan Maharaj prayers, Jai Jai Satchitswaroopa Aarti lyrics, Aarti in Marathi, Swami Ganraya Aarti, devotional prayers, Gajanan Maharaj Bhajan, Ganraya Bhajan, Gajanan Maharaj Aarti lyrics, Aarti for Lord Gajanan, गजानन महाराज आरती मराठी, गजानन महाराज ची आरती, जय जय सचित स्वरूपा स्वामी गणराया'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/gajanan-maharaj.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/gajanan-maharaj.webp'
          },
          ],
        }
      },
    
      components: {
        },
        data() {
          return {
            title: 'Jai Jai Satchitswaroopa Swami Ganraya | Gajanan Maharaj Aarti - जय सत्चितस्वरूपा स्वामी गणराया (गजानन महाराजांची आरती)',
            langauageMarathi: true
          }
        },
        layout: 'detailsPage-withoutFooter',
        
        jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/gajanan-maharaj"
        },
        "headline": "Jai Jai Satchitswaroopa Swami Ganraya - जय सत्चितस्वरूपा स्वामी गणराया (गजानन महाराजांची आरती)",
        "name" : "Jai Jai Satchitswaroopa Swami Ganraya - Gajanan Maharaj Aarti",
        "description": "Explore the full lyrics of Aarti 'Jai Jai Satchitswaroopa Swami Ganraya' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/gajanan-maharaj.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    }, 
    
    
        computed: {
    
        },
        methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    
      }
      
    